import React, { Component } from 'react';
import { map, get, filter, includes, size } from 'lodash';
import { Box, Card, Row, HasPermissions, Column, InfoTag, Subtitle, Text, Loading, Icon, FlexContainer } from '../../common';

export default class PermissionCard extends Component {
    render () {
        const { item, onEdit, profilesData, handleModal } = this.props;
        const { id } = item;
        const permissionsByProfile = map(profilesData, ({ permissions }) => map(map(permissions, 'accesses'), (item) => item));
        const profiles = permissionsByProfile.map(subArray => [].concat(...subArray))

        return (
            <Box width={['100%', '50%', '33.33%']}>
                <Card
                    margin={5}
                    leftHeader={() => (
                        <Column>
                            <Text text={get(item, 'name')} size={13} strong />
                            <Subtitle text={get(item, 'id', '')} color='#848484' />
                        </Column>
                    )}
                    rightHeader={() => (
                        <Row align='center' justify='flex-end'>
                            <HasPermissions to={['permissions-page:edit']}>
                                <Icon name='edit' size={11} left={10} onClick={() => onEdit(item)} pointer />
                            </HasPermissions>
                            <HasPermissions to={['permissions-page:edit']}>
                                <Icon name='trash' size={11} left={10} onClick={() => handleModal(item)} pointer />
                            </HasPermissions>
                        </Row>
                    )}
                    bodyChildren={() => (
                        <FlexContainer direction='column'>
                            <FlexContainer direction='column' mT={10}>
                                <Text strong text='Permisos' />
                                <Row mT={5}>
                                    {map(get(item, 'resources'), (name, index) => {
                                        const profilesAssignedCount = size(filter(profiles, (permissions) => {
                                        return includes(permissions, name)
                                    }));
                                        return <InfoTag key={index}>{`${name} - ${profilesAssignedCount}`}</InfoTag>
                                    }) }
                                </Row>
                            </FlexContainer>
                        </FlexContainer>
                    )}
        />
            </Box>
        );
    }
}
